// extracted by mini-css-extract-plugin
module.exports = {"text":"bodyCopySkins-large-text-5123af44"};